import { AxiosError } from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { getDeviceTelemetry, postDeviceTelemetry } from '../api';
import {
  postDeviceTelemetryRequest,
  postDeviceTelemetrySuccess,
  postDeviceTelemetryFailure,
  getDeviceTelemetryRequest,
  getDeviceTelemetrySuccess,
  getDeviceTelemetryFailure
} from '../features/telemetry/device-telemetry-slice';

import {
  DeviceTelemetryRequest,
  PostDeviceTelemetryPayload
} from '../types/device-telemetry';
import { unmarshalError } from '../utils/common';

function* handlePostDeviceTelemetryRequest(
  action: PayloadAction<PostDeviceTelemetryPayload>
) {
  const id = action.payload.device.device_serial_nr ?? '';

  try {
    const response: DeviceTelemetryRequest = yield call(
      postDeviceTelemetry,
      action.payload
    );
    yield put(postDeviceTelemetrySuccess({ id, response }));
  } catch (error) {
    const message = 'api-errors.telemetry.device-telemetry.generic-error';
    const errorRet = unmarshalError(message, error as AxiosError);
    yield put(
      postDeviceTelemetryFailure({
        id,
        error: errorRet
      })
    );
  }
}

function* handleGetDeviceTelemetryRequest() {
  try {
    const response: DeviceTelemetryRequest[] = yield call(getDeviceTelemetry);
    yield put(getDeviceTelemetrySuccess(response));
  } catch (error) {
    const message = 'api-errors.telemetry.device-telemetry.generic-error';
    const errorRet = unmarshalError(message, error as AxiosError);
    yield put(getDeviceTelemetryFailure(errorRet));
  }
}

function* DeviceTelemetrySaga(): Generator {
  yield takeEvery(
    postDeviceTelemetryRequest.type,
    handlePostDeviceTelemetryRequest
  );
  yield takeLatest(
    getDeviceTelemetryRequest.type,
    handleGetDeviceTelemetryRequest
  );
}

export default DeviceTelemetrySaga;
